import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';

import { BusinessUserManagementPage } from '../business-user-management/business-user-management';
import { BusinessUserProvider } from '../../providers/business-user';

@Component({
  selector: 'page-business-user-list',
  templateUrl: 'business-user-list.html',
})
export class BusinessUserListPage {
	isLoading: boolean = false;
	
	loadingMsg: any = "Loading...";

	page: any = 1;
	size: any = 20;
	term: any = "null";

	lastRequestReturnedValues: boolean = false;

	hasUsers: any=false;

	constructor(		
		public businessUserProvider: BusinessUserProvider, 
		public alertCtrl: AlertController,
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		this.isLoading = true;

		this.loadingMsg = "Loading..."
		this.load(()=>{
			this.isLoading = false;
		});
	}

	doRefresh(refresher) {
		this.load(()=>{
		  refresher.complete();
		})
	}  	

	search(ev){
		this.term = this.term = ev.target.value;	
		this.businessUserProvider.users = [];

		if(this.term=="" || !this.term)
			this.term = "null";
		
		this.page = 1;

		this.load(null);
	}	

	createUser(){
		this.navCtrl.push(BusinessUserManagementPage);
	}

	load(cb){
		let params = {
			term: this.term,

			cb: (users)=>{
				this.hasUsers = (users.length == 0 && this.page == 1) ? false : true;
				this.lastRequestReturnedValues = (users.length==0) ? false : true;

				if(this.page == 1){
					this.businessUserProvider.users = users;	
				}else{
					for (var i = users.length - 1; i >= 0; i--) {
						this.businessUserProvider.users.push(users[i]);
					}					
				}
				
				if(cb)
					cb();
			}
		}

		this.businessUserProvider.getUsers(params);
	}	

}



// WEBPACK FOOTER //
// ./src/pages/business-user-list/business-user-list.ts